// extracted by mini-css-extract-plugin
module.exports = {"tabletMiddle":"(max-width: 768px)","locator":"locator-79KBQ","destination":"destination-18xBA","orderGroup":"orderGroup-z3c5w"};